import React from 'react';
import { Form } from '@ant-design/compatible';
import { Input, message, Modal } from 'antd';
import {
  PASSWORD_RESET_REQUEST_ERROR,
  PASSWORD_RESET_REQUEST_SUCCESS,
} from './../../actions/PasswordReset';

const FormItem = Form.Item;

class PasswordResetRequestForm extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  /**
   * Action success & errors handling
   * @param prevProps - previous props from earlier state
   */
  componentDidUpdate(prevProps) {
    this.handleActionResponseNotifications(this.props.actionResponse);
  }

  /**
   * Handles notifications for the action response
   * @param actionResponse - the response of the action made
   */
  handleActionResponseNotifications(actionResponse) {
    if (actionResponse === null) {
      return;
    }

    switch (actionResponse.get('type')) {
      case PASSWORD_RESET_REQUEST_SUCCESS:
        message.success('Anmodning blev sendt');
        this.handleCancel();
        break;

      case PASSWORD_RESET_REQUEST_ERROR:
        message.error('Der er opstået en fejl, prøv igen.');
        break;

      default:
        break;
    }
    this.props.clearActionResponse();
  }

  /**
   * Validates & submits data to backend
   * @param evt is the submit button.
   */
  handleSubmitPasswordResetRequest = (evt) => {
    evt.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const email = values;
        this.props.passwordResetRequest(email);
      }
    });
  };

  /**
   * Closes create window & resets all fields on cancel
   */
  handleCancel = () => {
    this.props.handleCancel();
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Modal
        title={'Anmod om nyt password'}
        visible={this.props.visible}
        onOk={this.handleSubmitPasswordResetRequest}
        onCancel={this.handleCancel}
        confirmLoading={this.props.isLoading}
      >
        <Form>
          <FormItem {...formItemLayout} label={'E-mail'}>
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'Email-adressen er ikke gyldig',
                },
                {
                  required: true,
                  message: 'Email skal udfyldes.',
                },
              ],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(PasswordResetRequestForm);
